import { useTheme } from "@mui/material/styles";
import { getGroupColors } from "../../shared/helpers";
function useBadgeColors({
  variant = "primary",
  color = "info",
  parentBg
}) {
  const theme = useTheme();
  const palette = getGroupColors(theme, parentBg);
  const variants = {
    primary: {
      badgeColor: palette.brandBackground,
      textColor: palette.brandContrast,
      iconColorKey: "brandContrast"
    },
    secondary: {
      badgeColor: palette.transparent,
      textColor: palette.contrast,
      iconColorKey: "contrast"
    },
    color: {
      badgeColor: palette[`${color}Background`],
      textColor: palette[`${color}Contrast`],
      iconColorKey: `${color}Contrast`
    },
    disabled: {
      badgeColor: palette.disable,
      textColor: palette.disableText,
      iconColorKey: "disableText"
    }
  };
  return variants[variant];
}
function getBadgeContent({
  size = "m",
  count,
  icon,
  iconColorKey
}) {
  let countProp = void 0;
  let iconProps = void 0;
  if (size !== "xs") {
    if (typeof count === "number" && count > 0) {
      countProp = count > 99 ? "99+" : count;
    } else if (icon && (typeof count !== "number" || count === 0)) {
      const iconSizeToken = size === "m" ? "xs" : "xxxs";
      iconProps = {
        size: iconSizeToken,
        color: iconColorKey
      };
    } else if (!icon && count === 0) {
      countProp = 0;
    }
  }
  return { countProp, iconProps };
}
export {
  getBadgeContent,
  useBadgeColors
};
